export const round = (value: number) => Math.floor(value * 2 + 0.5) / 2
